export const GATE_CODES = [
    'thread-closed',
    'no-ticket-no-halo-write',
    'consequential-needs-confirmation',
    // Name is historical: this code originally meant "needs a team member AND a
    // ticket that names a contact." Andrew dropped the ticket/contact half
    // 2026-08-24 (device-targets design §Security/§Locked decisions — tickets on
    // a device thread are optional, exactly like person threads, and a
    // device-scoped thread has no contact to name at all). The refusal is now
    // staff-only, but the code stays: it is the shared contract's stable
    // identifier, and renaming it would break anything already matching on it
    // for no behavioural gain.
    'outbound-device-needs-tech-and-ticket',
    'inbound-needs-contact',
    'handoff-needs-ticket',
    'log-call-needs-ticket',
    'needs-halo',
    'otp-destination-not-of-record',
    'otp-needs-matched-contact',
    'handle-ceiling',
    'not-authenticated',
    'not-owner',
    'not-admin',
    'field-not-editable',
    'not-an-operator',
    // Task 41: `create-ticket`'s Halo contact lookup (`routes/operations.ts`, `halo/contacts.ts`).
    // Neither is a gate-module refusal in the `assertGate` sense — both surface mid-action, once
    // the route has already started resolving the thread's stored contact identifier to the
    // numeric Halo user id `POST /Tickets` requires — but `GateRefusal` is thrown directly from
    // `routes/operations.ts` for `not-authenticated` too, for the same reason: it is what turns a
    // refusal into a legible 409 (`OpsError`, not the console's generic-500 copy) instead of an
    // opaque 500 from deep inside the ticket writer.
    'contact-not-resolvable',
    'contact-ambiguous',
];
/** Thrown by assertGate. The `code` is what a caller switches on; `message` is shown to a human. */
export class GateRefusal extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.name = 'GateRefusal';
        this.code = code;
    }
}
